<template>
  <navroot />
  <a-spin wrapperClassName="spin-box list-box" :spinning="loading">
    <div class="content-box">
      <div class="back-cover" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }" v-if="backgroundImage && !int">
      </div>
      <div class="list-box fadeIn" :class="{ blur: isOpenClass }" v-if="!int">
        <div class="list-content">
          <div class="list-box-title">
            <div class="list-title">{{ classInfo?.ClassName }}</div>
          </div>
          <div class="list">
            <div class="list-item" v-for="(item, index) of intList" @click="chooseItem(item, index)"
              @mouseenter="switchBackground(item)" @mouseleave="defultBackground()">
              <div class="list-num">{{ index + 1 }}</div>
              <div class="item-content">
                <p class="item-intname">{{ item.InductionName }}</p>
                <p class="item-des" v-if="item.Description">{{ item.Description }}</p>
              </div>
              <div class="code-list">
                <a-tooltip v-for="code of item.allcode" @click.stop="openUrl(code)" v-if="!item.isFinished">
                  <template #title>{{ code.typeName }}：{{ code.Title }}</template>
                  <div class="code-item" :class="{ submited: code.isSubmited }">
                    <svg class="i-icon code-icon" v-if="!code.isSubmited">
                      <use :xlink:href="code.icon" />
                    </svg>
                    <svg class="i-icon code-icon" v-if="code.isSubmited">
                      <use xlink:href="#icon-duihao" />
                    </svg>
                  </div>
                </a-tooltip>
                <div class="int-finished" v-if="item.isFinished">
                  <svg class="i-icon code-icon">
                    <use xlink:href="#icon-duihao" />
                  </svg>
                  <span>已完成训练</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-describe-box">
          <div class="list-describe">
            <div class="describe">
              <div class="describe-item">
                <div class="describe-top">
                  <img src="../../assets/images/list/sum.png" />
                  <span>总分</span>
                </div>
                <p class="value">{{ userScore.Score }}</p>
              </div>
              <i class="i-icon thread"></i>
              <div class="describe-item">
                <div class="describe-top">
                  <img src="../../assets/images/list/finish.png" />
                  <span>完成度</span>
                </div>
                <div class="value">
                  <p>{{ userScore.submitPercent }}</p>
                  <p class="percent">%</p>
                </div>
              </div>
              <i class="i-icon thread"></i>
              <div class="describe-item">
                <div class="describe-top">
                  <img src="../../assets/images/list/ranking.png" />
                  <span>排名</span>
                </div>
                <p class="value">{{ ranking }}</p>
              </div>
            </div>
            <div class="ranking-list-box">
              <div class="ranking-name-box">
                <img src="../../assets/images/list/ranking-list.png" />
                <p>排行榜</p>
              </div>
              <div class="ranking-title">
                <p class="title-name">排名</p>
                <p class="title-name" id="title-name">姓名</p>
                <p class="title-name">完成度</p>
                <p class="title-name">得分</p>
              </div>
              <img src="../../assets/images/list/thread1.png" />
              <div v-for="(score, index) in classScoreList">
                <div class="ranking-list" v-if="index < 5 && (index + 1) != ranking">
                  <p class="ranking-item">{{ index + 1 }}</p>
                  <p class="ranking-item" id="title-name">{{ score.NickName }}</p>
                  <p class="ranking-item">{{ score.submitPercent }}%</p>
                  <p class="ranking-item">{{ score.Score }}</p>
                </div>
                <div class="ranking-list my-background" v-else-if="index < 5 && (index + 1) === ranking">
                  <p class="ranking-item">{{ ranking }}</p>
                  <p class="ranking-item" id="title-name">{{ userScore.NickName }}</p>
                  <p class="ranking-item">{{ userScore.submitPercent }}%</p>
                  <p class="ranking-item">{{ userScore.Score }}</p>
                </div>
              </div>
              <div class="ranking-list my-background" v-if="ranking > 5">
                <p class="ranking-item">{{ ranking }}</p>
                <p class="ranking-item" id="title-name">{{ userScore.NickName }}</p>
                <p class="ranking-item">{{ userScore.submitPercent }}%</p>
                <p class="ranking-item">{{ userScore.Score }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="single-box list-box fadeIn" :class="{ blur: isOpenClass }" v-if="int">
        <div class="list-content">
          <div class="title-box">
            <div class="list-hanlder">
              <svg class="i-icon return-icon" @click="returnList()">
                <use xlink:href="#icon-youjiantou-cu" />
              </svg>
              <div class="hanlder-item">
                <i class="i-icon icon-pie"></i>
                <span>{{ int.submitPercent }}%</span>
              </div>
            </div>
          </div>
          <div class="list">
            <div class="list-item" v-for="code of int.allcode" @click="openUrl(code)">
              <svg class="i-icon code-icon">
                <use :xlink:href="code.icon" />
              </svg>
              <div class="code-name">{{ code.typeName }}：{{ code.Title }}</div>
              <div class="code-hanlder">
                <svg class="i-icon code-icon" v-if="code.isSubmited">
                  <use xlink:href="#icon-duihao" />
                </svg>
                <span class="code-noSubmited" v-if="!code.isSubmited">待完成</span>
              </div>
            </div>
          </div>
        </div>
        <div class="list-describe-box">
          <div class="list-describe">
            <p class="item-unit-num">单元{{ unitNum }}</p>
            <p class="item-intname">{{ int.InductionName }}</p>
            <p class="item-des">{{ int.Description }}</p>
            <i class="i-icon describe-cover" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- iframe弹窗 -->
    <div class="new-popupbox" v-if="iframeUrl">
      <div class="hanlder-box">
        <svg class="i-icon popup-close" @click="iframeUrl = ''">
          <use xlink:href="#icon-guanbi" />
        </svg>
      </div>
      <LoadingOutlined class="iframe-loading" />
      <iframe id="iframe-box" class="box-content iframe-content" :src="iframeUrl" scrolling="no" frameborder="0"
        name="ifd"></iframe>
    </div>
  </a-spin>
</template>

<script>
import navroot from "../nav/nav.vue";
import { LoadingOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    navroot, LoadingOutlined
  },
  name: "login",
  data() {
    return {
      classGuid: '',
      intGuid: '',
      iframeUrl: '',
      backgroundImage: '../../assets/images/list/background.png',
      user: null,
      classInfo: null,
      int: null,
      isOpenClass: false,
      loading: true,
      intList: [],
      groupList: [],
      classScoreList: [],
      userScore: {},
      ranking: 0,
      unitNum: 0,
      submitPercent: 100,
      score: 0
    }
  },
  async mounted() {
    let classGuid = this.$route.params.classId;
    this.refreshList(classGuid);

    this.intGuid = this.$route.query.intId || '';
    let that = this;
    if (window.history && window.history.pushState) {
      $(window).on('popstate', function () {
        that.intGuid = '';
        that.int = null;
      })
    }
  },
  methods: {
    //刷新页面
    async refreshList(classGuid) {
      this.classGuid = classGuid;
      this.intGuid = '';
      this.int = null;
      this.loading = true;

      let user = this.$store.state.userInfo;
      if (!user) {
        this.$message.warning('身份信息已经过期，请重新登录');
        return this.$router.push(``);
      }
      this.setClassInfo();
      this.user = user;
    },
    //获取班级信息
    async setClassInfo() {
      let res = await this.$api.classMessage.getClassInfo({ classGuid: this.classGuid });
      if (res.statusCode != 200) return this.$message.warning('获取班级信息失败');

      this.classInfo = res.data.classInfo;
      this.$store.commit('currentClass', this.classInfo);

      this.intList = res.data.inductionList;
      this.groupList = res.data.groupList;

      this.intList.forEach(item => {
        item.allcode = [];
        item.children.forEach(child => {
          let clist = child.data.filter(item => item.pushType != 'pushModel');
          item.allcode = [...item.allcode, ...clist];
        })
      });
      this.loading = false;

      this.setStudentScore()
    },
    //获取学生提交记录
    async setStudentScore() {
      let res = await this.$api.classMessage.getScoreList({ classGuid: this.classGuid });
      if (res.statusCode != 200) return this.$message.warning('获取学生信息失败');
      let userList = res.data || [];
      userList.sort((a, b) => b['Score'] - a['Score']); //按成绩排序（降序）
      this.classScoreList = userList

      let allSubmitNum = 0;
      let allNeedNum = 0;
      this.intList.forEach(item => {
        item.submitNum = 0;
        item.isFinished = item.allcode.length > 0 ? true : false;
        item.allcode.forEach(code => {
          code.submitNum = 0;
          code.isSubmited = false;
          userList.forEach(user => {
            let record = user.record.find(reItem => reItem.id == code.Guid);
            
            if (record && record.state == 1) {
              code.submitNum += 1;
              if (user.PK_UserGuid == this.user.PK_UserGuid) {
                item.submitNum += 1;
                code.isSubmited = true;
              }
            }
          })
          if (!code.isSubmited) item.isFinished = false;
        })
        item.submitPercent = item.allcode.length > 0 ? Math.round(item.submitNum / item.allcode.length * 100) : 0;
        allNeedNum += item.allcode.length;
        allSubmitNum += item.submitNum;
      });
      if (allNeedNum > 0) this.submitPercent = Math.round(allSubmitNum / allNeedNum * 100);
      //找到我
      for (var i = 0; i < userList.length; i++) {
        if (this.user.PK_UserGuid == userList[i].PK_UserGuid) {
          this.ranking = i + 1;
          this.userScore = userList[i];
          this.score = userList[i].Score;
        }
      }
      if (this.intGuid) {
        this.intList.forEach((item, i) => {
          if (item.PK_InductionGuid == this.intGuid) {
            this.int = item;
            this.unitNum = i + 1;
          }
        })
      }
    },
    //打开
    openUrl(item) {
      if (item.ProjectCode == "rpa") {
        let url = item.address.replace("${token}", this.user.token)
        window.open(url);
      }
      else window.open(item.address);
      //this.iframeUrl = `https://clientpassport.lessonplan.cn/auth/checkLogin?token=${this.user.token}&redirectURI=${item.address}%3Fshowtype=screenNav%26fullscreeon=1`;
    },
    //选择其中一个
    chooseItem(item, index) {
      this.$router.push(`/list/${this.classGuid}?intId=${item.PK_InductionGuid}`);
      this.int = item;
      this.unitNum = index + 1;
      if (item.Cover) this.backgroundImage = item.Cover;
    },
    //返回
    returnList() {
      this.$router.push(`/list/${this.classGuid}`);
      this.int = null;
      // this.defultBackground();
    },
    //切换背景
    switchBackground(item) {
      if (item.Cover) this.backgroundImage = item.Cover;
    },
    //默认背景
    defultBackground() {
      this.backgroundImage = '../../assets/images/list/background.png';
    },
    //跳转班级
    routeClass(item) {
      this.isOpenClass = false;
      this.$router.push(`${item.PK_ClassGuid}`);
      this.refreshList(item.PK_ClassGuid);
    }
  },
  // destroyed() {

  // },
}
</script>

<style scoped lang="scss">
@import "./list.scss";
</style>